import {
  LOAD_SONG_AGGREGATE,
  UNLOAD_CURRENT_ARTIST,
  UNLOAD_CURRENT_SONG,
  CLEAR_SONG_TIMELINE,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const aggregate = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
    case UNLOAD_CURRENT_SONG:
    case CLEAR_SONG_TIMELINE:
      return null;

    case LOAD_SONG_AGGREGATE:
      return loadReducer(state, action);
    default:
      return state;
  }
};
